import React, { FC } from 'react';
import classNames from 'classnames';

import Link from '../../Controls/Link';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';
import NoticeDot from '../../Feedback/NoticeDot';

import css from './style.module.scss';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface IProps {
  link: string;
  icon: string;
  text: string;
  selected?: boolean;
  withNoticeDot?: boolean;
  onClick?: () => void;
  size?: 'md' | 'lg';
  qaTag?: string;
}

const NavItem: FC<IProps> = ({
  link,
  icon,
  text,
  selected,
  withNoticeDot,
  onClick,
  size,
  qaTag,
}) => {
  return (
    <Link
      to={link}
      onClick={onClick}
      textDecoration="none"
      className={classNames(css.navItem, {
        [css.selected]: selected,
        [css[`navItem_size_${size}`]]: size,
      })}
      {...setQaAttribute(qaTag)}
    >
      <span className={css.navItem__content}>
        <span className={css.navItem__icon}>
          <Icon id={icon} />
        </span>
        <span className={css.navItem__text}>{text}</span>
        {withNoticeDot && <NoticeDot />}
      </span>
    </Link>
  );
};

export default NavItem;
